"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OntologyChip = exports.parseUrlForOntologyChip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const slim_1 = require("@blockprotocol/type-system/slim");
const material_1 = require("@mui/material");
const react_1 = require("react");
const ontology_icon_1 = require("./ontology-icon");
const parseUrlForOntologyChip = (url) => {
    const validationResult = (0, slim_1.validateVersionedUrl)(url);
    if (validationResult.type === "Err") {
        throw new Error(`Could not validate url as VersionedUrl: ${validationResult.inner.reason}`);
    }
    const parsed = validationResult.inner;
    const parsedUrl = new URL(parsed);
    const domain = parsedUrl.host === "localhost:3000" ? "localhost" : parsedUrl.host;
    const path = parsedUrl.pathname.slice(1);
    const isHash = domain === "hash.ai";
    const icon = isHash ? (0, jsx_runtime_1.jsx)(ontology_icon_1.OntologyIcon, {}) : null;
    return { domain, path, icon };
};
exports.parseUrlForOntologyChip = parseUrlForOntologyChip;
// @todo make this take the id
const OntologyChip = ({ icon, domain, path, sx = [], ...props }, ref) => ((0, jsx_runtime_1.jsxs)(material_1.Stack, { ...props, direction: "row", sx: [
        (theme) => ({
            height: 26,
            backgroundColor: theme.palette.gray[10],
            borderRadius: "13px",
            overflow: "hidden",
            width: "fit-content",
            alignItems: "stretch",
            [`.${material_1.typographyClasses.root}`]: {
                fontSize: 12,
            },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
    ], ref: ref, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", bgcolor: "gray.20", pl: "13px", pr: "15px", sx: {
                clipPath: "polygon(0 0, 100% 0, calc(100% - 7px) 100%, 0 100%)",
            }, children: [icon && ((0, jsx_runtime_1.jsx)(material_1.Box, { width: 16, height: 16, mr: 1.25, overflow: "hidden", position: "relative", children: icon })), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: (theme) => ({
                        color: theme.palette.gray[80],
                        fontWeight: 500,
                    }), children: domain })] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: material_1.Stack, direction: "row", sx: (theme) => ({
                alignItems: "center",
                pr: 1.25,
                pl: "4px",
                color: theme.palette.gray[60],
                display: "flex",
                flexShrink: 1,
                minWidth: 0,
                [`.${material_1.typographyClasses.root}`]: {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    "&:last-of-type:not(:nth-of-type(1))": {
                        // Place the overflow ellipsis at the beginning, not the end
                        "&:before": {
                            // Ensure special characters aren't placed at the end
                            // @see https://stackoverflow.com/questions/9793473/text-overflow-ellipsis-on-left-side#comment82783230_9793669
                            content: '"\\00200e"',
                        },
                        direction: "rtl",
                        textAlign: "left",
                    },
                },
            }), children: path })] }));
const OntologyChipForwardRef = (0, react_1.forwardRef)(OntologyChip);
exports.OntologyChip = OntologyChipForwardRef;
